import { render, staticRenderFns } from "./FormControls.vue?vue&type=template&id=1b7661a6&"
import script from "./FormControls.vue?vue&type=script&lang=ts&"
export * from "./FormControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports